import { useQuery } from 'react-query';
import { z } from 'zod';

import { queryKey } from '../chapters.query-keys';
import { getChaptersGroupParagraphs } from '../infrastructure/get-chapter-group-paragraphs';

export const useGetGroupChapterParagraphsQuery = (chapterId: string) => {
    return useQuery({
        queryKey: [queryKey.chapters(), chapterId],
        queryFn: () => getChaptersGroupParagraphs(chapterId),
        onError(error) {
            if (error instanceof z.ZodError) {
                console.log('error from useGetChapterQuery', error);
            }
        },
    });
};
